import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import "./Footer.css"

export const Footer = () => {

  const year = new Date().getFullYear()

  return (
    <Row>
      <strong className="pull-left ml-2 mr-4">
        Copyright &copy; {year} <a href="http://getbyond.com">Byond IOT Enterprise</a>. All rights reserved.
      </strong> 
      <p className="pull-right">
        <b>Data do build:</b> {process.env.REACT_APP_BUILD_DATE}
      </p>
    </Row>
  )
}



// WEBPACK FOOTER //
// ./src/component/Footer/Footer.js